import React, { useState } from 'react';
import { useCollection } from '../hooks/useCollection';
import { Users, Search, Loader2 } from 'lucide-react';

const AllVillagers = () => {
  const { documents: villagers, isPending, error } = useCollection('villagers'); // Assuming a 'villagers' collection
  const [searchTerm, setSearchTerm] = useState('');

  const filteredVillagers = villagers?.filter(v => 
    v.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    v.fatherName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="max-w-7xl mx-auto py-10 px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-10">
        <Users className="mx-auto h-12 w-12 text-blue-600" />
        <h1 className="mt-4 text-4xl font-extrabold tracking-tight text-gray-900">Our Community</h1>
        <p className="mt-4 max-w-2xl mx-auto text-xl text-gray-500">Directory of the respected members of our village.</p>
      </div>

      <div className="mb-6 max-w-lg mx-auto">
        <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
            <input 
                type="text"
                placeholder="Search by name or father's name..."
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border rounded-full bg-white shadow-sm"
            />
        </div>
      </div>

      {isPending && <Loader2 className="animate-spin mx-auto text-blue-600" size={32} />}
      {error && <p className="text-center text-red-500 bg-red-100 p-3 rounded-md">Error: {error}</p>}

      <div className="overflow-x-auto bg-white rounded-lg shadow">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Father's Name</th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Family ID</th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Gender</th>
              <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Age</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {filteredVillagers && filteredVillagers.map(person => (
              <tr key={person.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{person.name}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{person.fatherName}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{person.familyId}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{person.gender}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{person.age}</td>
              </tr>
            ))}
            {!filteredVillagers && !isPending && <tr><td colSpan="5" className="text-center py-10">No villagers found.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllVillagers;
